import {Validator} from 'vee-validate';

const initUserBodyDetails = (errorFunction) => {
  Validator.extend('bodyParams', {
    getMessage: errorFunction,
    validate: (value, args) => {
      // if field is "heightRemainder" and value is:
      // not a number and not whitespace(I'm allowing whitespaces but I'll trim them before submitting form data)
      if (args[0] === 'heightRemainder' && /\D/.test(value) && !/\s/.test(value)) {
        return false;
      }

      if (args[0] !== 'heightRemainder') {
        if (
          /\D/.test(value.trim()) ||
          ((/\s/.test(value) || parseInt(value) === 0) && (parseInt(value) === 0 || /\D/.test(value.trim())))
        ) {
          return false;
        }
      }

      return true;
    },
  });
};

export {initUserBodyDetails};
